export default "__VITE_ASSET__4ad2f197__"